import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/fc5035dc-a0cd-4f98-bb38-f209be7488d2";
export const REGISTER_URL = "https://a.ntrk2.com/e9ebba20-d6c1-4f17-af37-996a77eacf65";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowfuno.kzw2a.com/download?openExternalBrowser=1&id=ueuk8dtqn10ncsj";

export * from "./codes";
export * from "./context";
